import { styled } from 'react-alicerce-components';

export const InputErrorMessageContainer = styled.label`
  color: #c53030 !important;
  font-weight: 600;
  font-family: var(--primary-font) !important;
  font-size: 12px !important;
`;
